function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23037",
    transform: "translate(-450.51 -191.727)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 679",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(450.51 191.727)",
    style: {
      fill: "#ffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.388 21.992a1.2 1.2 0 0 1-1.2 1.2H11.8a1.2 1.2 0 0 1-1.2-1.2 7.2 7.2 0 0 1 7.2-7.2h2.4a7.2 7.2 0 0 1 7.188 7.2zM18.992 4a4.8 4.8 0 1 0 4.8 4.8 4.8 4.8 0 0 0-4.8-4.8zM8.2 4A4.8 4.8 0 1 0 13 8.8 4.8 4.8 0 0 0 8.2 4zm.852 17.992a9.733 9.733 0 0 1 3.048-6.765 13.884 13.884 0 0 0-3.376-.427H7.669A6.681 6.681 0 0 0 1 21.464v.528a1.2 1.2 0 0 0 1.2 1.2h7.065a3.6 3.6 0 0 1-.216-1.2z",
    transform: "translate(461.582 203.131)",
    style: {
      fill: "#f5d8a8"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.f69a881e7ed1f139977a00757c5cde87.svg";
export { ForwardRef as ReactComponent };